module.exports = __webpack_public_path__ + "static/virtual-reality-accomplishments-impact-706906493a13497471da8900c1b6cb1f.jpg";